import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { Actions } from "@/store";
import Note from "@/components/note/Note.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotePage',
  setup(__props) {

const store = useStore();
const route = useRoute();

onMounted(() => {
  store.dispatch(Actions.GetApplications);
  store.dispatch(Actions.GetNote, route.params.id);
  store.dispatch(Actions.GetShortcuts);
  store.dispatch(Actions.GetNotes);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Note))
}
}

})